import { Session } from '@supabase/supabase-js';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { appConfig } from 'src/app/app-config';
import { supabaseClient } from 'src/auth/supabase';

const ACCESS_TOKEN_KEY = appConfig.supabase.cookies.accessTokenKey as string;
const REFRESH_TOKEN_KEY = appConfig.supabase.cookies.refreshTokenKey as string;

type SupabaseDataResponse = { session: Session | null };

export const useInitializeSupabase = (config?: MutationOptions<SupabaseDataResponse, Error>) =>
    useMutation<SupabaseDataResponse, Error>({
        ...config,
        mutationKey: ['auth', 'supabase', 'initialize'],
        mutationFn: async () => {
            const accessToken = Cookies.get(ACCESS_TOKEN_KEY);
            const refreshToken = Cookies.get(REFRESH_TOKEN_KEY);

            if (accessToken && refreshToken) {
                supabaseClient.auth.setSession({
                    access_token: accessToken,
                    refresh_token: refreshToken,
                });
            }

            const { data, error } = await supabaseClient.auth.getSession();

            if (error) throw error;

            return data;
        },
        gcTime: Number.POSITIVE_INFINITY,
    });
